export default "__VITE_ASSET__n_x119vU__"